module.exports = __webpack_public_path__ + "img/live-time.c355a2b3.svg";